<template>
  <div class="insurance-container">
    <img class="header-bg" :src="require('@/assets/imgs/insure_show.png')" />
    <div style="margin: 0 .24rem;">
      <div class="explain">
        <span class="start">“警保联动”</span>
        <span>是交警部门在职责范围内依法与 中国人保共同开展工作。交警部门组织交警人员提供 法律支持，人保公司查勘员通过警保联动机制优化人 力资源，快速到达现场，现场定责，调解小额人伤， 协助联系车辆维修，快处快撤，提高交通事故的处理 效率，提升群众满意度的惠民工程。</span>
      </div>
      <div class="explain">
        <span class="start">“交强险”</span>
        <span>险种，是国家法律强制机动车所有人 或管理人购买相应的责任保险，在最大程度上为交通 事故受害人提供了及时和基本的保障。“交强险”负 有更多的交通管理职能，不仅有利于道路交通事故受 害人获得及时有效的经济保障和医疗救治，而且有助 于减轻交通事故肇事方的经济负担，是国家维护交通 稳定的重要手段。</span>
      </div>
      <div class="stress">
        <span>保畅通、惠民生、增福祉！</span>
      </div>
    </div>
    <div style="height:5rem"></div>
    <van-button @click="handleGoClick" type="primary" block color="#fe5958">办理交强险</van-button>
  </div>
</template>

<script>
import { getJsapiTicket } from "@/api/common";
export default {
  data() {
    return {
      belongerId: "",
      platformId: "",
    };
  },
  created() {
    document.title = "警保联动 交强险 掌上办";
    this.belongerId = this.$route.query.belongerId || "";
    this.platformId = this.$route.query.platformId || "";
  },
  mounted() {
    let sUrl = location.href.split("#")[0];
    let sImgUrl = "http://nywx.e-ibdt.cn/file/logo/logo_picc.png";
    getJsapiTicket({ appid: process.env.WXKey, url: sUrl }).then((res) => {
      if (res.code === 0) {
        this.$ComTools.wxShare(
          res.data,
          sUrl,
          sImgUrl,
          "警保联动 交强险 掌上办"
        );
      }
    });
  },
  methods: {
    handleGoClick() {
      this.$router.push({
        path: "/insure/electricform",
        query: { belongerId: this.belongerId, platformId: this.platformId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.insurance-container {
  width: 100%;
  min-height: 100%;
  .header-bg {
    width: 100%;
  }
  .explain {
    margin-top: 0.5rem;
    font-size: 1rem;
    letter-spacing: 0.1rem;
  }

  .explain .start {
    font-size: 1.2rem;
    margin-left: 0.5rem;
  }

  .stress {
    text-align: center;
    margin: 0.2rem 0.5rem;
    font-size: 1.4rem;
    font-weight: 600;
  }
  /deep/ .van-button {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/insurance/electric.vue